import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { ReportsService } from '../../../../reports/services/reports.service';
import { Constants } from '../../../../../app.const';
import { ReportsConstants } from '../../../../reports/reports.const';
import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-available-employees',
  templateUrl: './available-employees.component.html',
  styleUrls: ['./available-employees.component.css']
})
export class AvailableEmployeesComponent implements OnInit {

  date: string;
  authUser: any = {};
  originalData: any;
  filterData: any;
  reportsConstants: any = ReportsConstants;
  private constants = Constants;

  constructor(
    private datePipe: DatePipe,
    private cookieManagerService: CookieManagerService,
    private reportsService: ReportsService,
  ) { }

  ngOnInit() {
    let date = new Date();
    this.date = this.datePipe.transform(date, this.constants.dateFormat);
    // get login user details
    this.getAuthUser();
    this.checkAdminUserPermission()
    
  }

  /**
   * kauhsalya
   * 2017-07-12
   * get the resource availability for current date
   */
  getResourceAvailability() {
    let body = { date: this.date }
    this.reportsService.getResourceAvailability(body).subscribe(
      res => {
        this.originalData = this.availableResourceFilter(res.data);
        this.filterData = this.sortByCurrentAvailability(this.originalData);
      }
    );
  }
  /**
   * kaushalya
   * 2017-07-12
   * get only available employee list
   * @param resourceData 
   */
  availableResourceFilter(resourceData) {
    let availableResult = resourceData.filter(data => {
      return data.current_availability > 0
    });
    return availableResult;
  }

  /**
   * kauhsalya
   * 2017-07-12
   * sort list by employee name
   * @param resourceData 
   */
  sortByCurrentAvailability(resourceData) {
    resourceData.sort(function (a, b) {
      return (b.name - a.name);
    });
    return resourceData;
  }
  /**
   * kaushalya
   * 2017-07-11
   * get log user details from the cookies
   */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  /**
   * kaushalya
   * 2017-07-11
   * check user is adminUser or supervisor to give view permission for div
   */

  checkAdminUserPermission() {
    if (this.authUser.user_role_id != WorkConstants.basicConstans.adminRoleId && this.authUser.user_role_id != WorkConstants.basicConstans.supervisorRoleId) {
      $('#available-emp').hide();
    } else {
      // get available employee list
      this.getResourceAvailability();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/available-employees/available-employees.component.ts